// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import { UNCAUGHT_ERROR } from 'errors'
import { setPathValidationsMessagesInDrawer } from 'redux/modules/pathValidationsDrawer'
import { parseValidationMessages } from 'redux/helpers'

const setPathsErrorValidations = err => (dispatch, getState) => {
  const newPathValidations = {}

  if (err?.json?.errors) {
    const parsedValidationMessages = parseValidationMessages(err.json.errors)

    Object.entries(parsedValidationMessages).forEach(([pathId, value]) => {
      newPathValidations[pathId] = {
        errors: value.messages,
        heading: value.heading,
        warnings: [],
      }
    })
  }

  // and then use the most recent set that we just got from the API.
  dispatch(setPathValidationsMessagesInDrawer(
    err.message || UNCAUGHT_ERROR,
    newPathValidations
  ))
}

export default setPathsErrorValidations
